import I18n from "i18n-js";

export const AmountFormatter = {
  // This comes from accounting.js v0.3.2
  // http://josscrowcroft.github.com/accounting.js/
  delocalize: function(value, separator) {
    if (typeof value === "number") {
      return value;
    }
    // Build regex to strip out everything except digits and separator:
    const regex = new RegExp("[^0-9" + separator + "]", "g");
    const unformatted = ("" + value)
      .replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
      .replace(regex, '');         // strip out any cruft

    const float = parseFloat(unformatted.replace(separator, '.')); // necessary to deal with commas
    return !isNaN(float) ? float : 0;
  },

  unformatAmount: function(amount) {
    const separator = I18n.lookup("number.currency.format.separator");
    const unlocalizedAmount = AmountFormatter.delocalize(amount, separator);
    const unlocalizedFloat = parseFloat(unlocalizedAmount);
    return unlocalizedFloat.toFixed(2);
  },

  formatAmount: function(amount) {
    return I18n.toCurrency(amount, {'unit': ''}).replace(/^\s+|\s+$/g, ''); // strip
  },

  centifyAmount: function(amount) {
    return Math.floor((amount * 100).toFixed(2));
  },

  localizeField: function(sourceField, targetField) {
    const enteredAmount = sourceField.val();
    const unlocalizedAmount = AmountFormatter.unformatAmount(enteredAmount);
    targetField.val(unlocalizedAmount);

    const localizedAmount = AmountFormatter.formatAmount(unlocalizedAmount);
    sourceField.val(localizedAmount);
  },

  centifyField: function(sourceField, targetField) {
    const enteredAmount = sourceField.val();
    const unlocalizedAmount = AmountFormatter.unformatAmount(enteredAmount);
    const centifyedAmount = AmountFormatter.centifyAmount(unlocalizedAmount);

    targetField.val(centifyedAmount);

    const localizedAmount = AmountFormatter.formatAmount(unlocalizedAmount);
    sourceField.val(localizedAmount);
  }
};

// Views and the Propshaft-served admin scripts reach it via the SEPA global.
window.SEPA = window.SEPA || {};
window.SEPA.AmountFormatter = AmountFormatter;
